module.exports = __webpack_public_path__ + "img/main_desktop.095ffd5c.png";